<template>
  <div id="app">
    <Navigation />
    <router-view />
    <Footer/>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default {
  name: 'App',
  components: {
    Navigation,
    Footer
  },
  async created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import './assets/scss/pandora-style.scss';
</style>
